// apiWithoutAuth.ts
import axios from 'axios';

const apiWithoutAuth = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiWithoutAuth;
